import {
  Button,
  StyleSheet,
  Text,
  View,
  Platform,
  TouchableOpacity,
} from "react-native";
import React, { useEffect, useState } from "react";
import * as RootNavigation from "../utilities/RootNavigation";
import AsyncStorageFunc from "../utilities/asyncStorage";
import {jwtDecode} from "jwt-decode";
import ModalAlert from "../common/ModalAlert";
import { useLogin } from "../context/loginProvider";

export default function Loading(props) {
  const { isLoggedIn, setIsLoggedIn } = useLogin();
  const [showLogoutModal, setShowLogoutModal] =useState(false);

 
  
  useEffect(() => {
    console.log(global.TimeoutError,'global.TimeoutError6')
    setTimeout(() => {
      AsyncStorageFunc.getData("TOKEN").then((token) => {
        console.log(token, "token splash");
        if (token && token != "") {
          let loginData = jwtDecode(token);
          global.token = token;
          global.userId = loginData.userId;
          global.userCd = loginData.userCd;
          global.fullName = loginData.fullName ? loginData.fullName : "";
          global.userType = loginData.userType;
          RootNavigation.navigate("Home");
        } else {
          console.log(props, "props splash");
          RootNavigation.navigate("Login");
        }
      });
    }, 500);
  }, []);

  return (
    <View style={styles.container}>
      {showLogoutModal ? (
            <View style={styles.overlayViewStyle}>
            <ModalAlert
                title={"Error"}
                message={global.TimeoutError}
                actionButton={"OK"}
                onCloseModal={() => {
                  setIsLoggedIn(false) 
                  setShowLogoutModal(false)
                  RootNavigation.navigate("Login");
                }}
            />
            </View>
        ) : null}
    
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    height: '100vh',
},
  overlayViewStyle: {
    position: "absolute",
    zIndex: 9999,
    backgroundColor: "rgba(52,52,52,0.9)",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    borderRadius: 15,
    marginLeft: 20,
    alignItems: "center",
    justifyContent: "center",
  },
});

